import { isValid, isToday } from "date-fns";
import { Goal, DailyTask, Milestone } from "../../types/goals";
import CurrentMilestone from "./CurrentMilestone";
import GoalHeader from "./GoalHeader";
import ProgressBar from "./ProgressBar";
import TodayTask from "./TodayTask";

interface MainTabContentProps {
    goal: Goal;
    dailyTasks: DailyTask[];
    milestones: Milestone[];
    getMilestoneProgress: (milestoneId: string) => number;
    updateTask: (taskId: string) => void;
    currentMilestone: Milestone | undefined;
    progress: number;
    completedTasks: number;
}
const MainTabContent = ({ goal, dailyTasks, milestones, getMilestoneProgress, updateTask, currentMilestone, progress }: MainTabContentProps) => {
    const todayTask = dailyTasks.find(task => isValid(task.date) && isToday(task.date));
    ;

    const handleCheckbox = () => {
        if (todayTask) {
            updateTask(todayTask._id);
        }
    }

    return (
        <div className="space-y-6">
            <GoalHeader goal={goal} />
            <ProgressBar progress={progress} />
            {currentMilestone && <CurrentMilestone milestone={currentMilestone} />}
            {todayTask && <TodayTask todayTask={todayTask} milestones={milestones} onCheckbox={handleCheckbox} />}
        </div>
    );
};

export default MainTabContent;